"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageUrl = void 0;
exports.imageUrl = "https://firebasestorage.googleapis.com/v0/b/gemunion-firebase.appspot.com/o/DO_NOT_REMOVE_LOGO.png?alt=media&token=85c376a8-33a0-4b6b-9285-2b9022287289";
//# sourceMappingURL=mocks.js.map